"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEvent = exports.JSLLTrackEvent = exports.JSLLExist = void 0;
exports.JSLLExist = function () { return window.taggingHelper !== undefined; };
exports.JSLLTrackEvent = function (eventConfig) {
    if (exports.JSLLExist()) {
        var defaultConfig = {
            behavior: 300,
            actionType: 'O',
            content: {},
        };
        var eventTag = __assign(__assign({}, defaultConfig), eventConfig);
        window.taggingHelper.trackEvent(eventTag);
    }
};
exports.trackEvent = function (eventConfig) {
    var trackConfig = {
        behavior: eventConfig.behavior,
        actionType: eventConfig.actionType,
        content: {
            contentName: eventConfig.contentName,
            id: eventConfig.id,
        }
    };
    exports.JSLLTrackEvent(trackConfig);
};
//# sourceMappingURL=telemetry.js.map